var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "20px",
    width: "20px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490.002 490.002",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.447,111.457c28.471,28.347,66.324,43.958,106.579,43.958c40.245,0,78.098-15.611,106.57-43.958l26.627-26.518 c2.13-1.766,5.655-8.603,0-14.465l-26.627-26.512c-28.472-28.348-66.324-43.959-106.57-43.959 c-40.256,0-78.108,15.611-106.579,43.959l-26.627,26.512c-5.592,6.236-1.924,12.551,0,14.465L138.447,111.457z M152.862,58.427 c24.613-24.509,57.342-38.008,92.164-38.008c34.812,0,67.54,13.499,92.154,38.008l19.37,19.279l-19.37,19.286 c-24.613,24.509-57.341,38.007-92.154,38.007c-34.822,0-67.551-13.498-92.164-38.007l-19.37-19.286L152.862,58.427z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.026,118.78c22.72,0,41.202-18.423,41.202-41.073c0-22.644-18.482-41.067-41.202-41.067s-41.202,18.423-41.202,41.067 C203.824,100.357,222.306,118.78,245.026,118.78z M245.026,57.056c11.464,0,20.785,9.266,20.785,20.65 c0,11.391-9.321,20.657-20.785,20.657c-11.464,0-20.785-9.266-20.785-20.657C224.241,66.322,233.562,57.056,245.026,57.056z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.079,312.095l-45.011-97.122c-0.004-0.009-0.008-0.018-0.012-0.027l-0.007-0.015c0,0-0.002-0.001-0.002-0.002 c-1.38-2.96-4.15-5.212-7.615-5.78l-189.762-31.054c-0.11-0.018-1.658-0.287-3.352,0.01l-189.71,31.044 c-3.339,0.548-6.19,2.711-7.617,5.782l-45.02,97.164c-4.072,10.052,5.727,14.918,9.261,14.5h34.813v122.145 c0,5,3.628,9.266,8.563,10.074l189.618,31.028c1.799,0.351,3.585,0.003,3.597,0l189.608-31.029 c4.935-0.808,8.564-5.074,8.564-10.074V326.595h34.822C490.838,325.911,490.981,315.477,489.079,312.095z M26.214,306.178 l36.028-77.753l167.45-27.4l-36.935,105.154H26.214z M234.818,467.782L65.463,440.068V326.595h134.533 c4.336,0,8.194-2.737,9.629-6.824l25.192-71.729V467.782z M424.579,440.068l-169.345,27.714V248.054l25.182,71.717 c1.435,4.087,5.294,6.824,9.63,6.824h134.533V440.068z M297.283,306.178l-36.925-105.154l167.44,27.4l36.038,77.753H297.283z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewProduct);
export default __webpack_public_path__ + "static/media/new-product.887624f95bcdc2f845055bdd3c9dab1a.svg";
export { ForwardRef as ReactComponent };